import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';

class NonCatalogStore extends EventEmitter {
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    workorderresponse = "";
    vendordetail = "";
    insertResponse
    handleNonCatalogStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.SupplierOrderEntry_PageLoad: {
                this.vendordetail = action.action.response;
                this.emit('Pageload');
                break;
            }
            case SDIConstants.methodNames.InsertSupplier_Entry: {
                this.insertResponse = action.action.response;
                this.emit('Insert');
                break;
            }
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheck');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;
            }
            case "NONCAT_UploadAttachments": {
                this.attachmentResponse = action.action.response;
                this.emit('attachmentResponse');
                break;
            }
            case "NONCAT_RemoveAttachment": {
                this.removeAttachmentResponse = action.action.response;
                this.emit('rmvAttach');
                break;
            }

            case "CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            case "InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
        }
    }
}

const objNonCatalogStore = new NonCatalogStore;
// Dispatcher code
Dispatcher.register(objNonCatalogStore.handleNonCatalogStore.bind(objNonCatalogStore));
export default objNonCatalogStore;